import React, { useContext } from "react";
import { themeContext } from "../../../Context";
import "./TrustBar.css";

const items = [
  { label: "عميل في السعودية واليمن ومختلف الدول العربية", value: "+800" },
  { label: "امتثال الفوترة الإلكترونية", value: "ZATCA" },
  { label: "حسابات ومبيعات ومخزون وتقارير", value: "وحدات متكاملة" },
  { label: "متابعة بعد التشغيل", value: "دعم مستمر" },
];

const TrustBar = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <section className="trust-bar" id="erp-trust" aria-label="مؤشرات الثقة والامتثال">
      <div className="trust-bar-zatca">
        <span className="trust-bar-zatca-badge">ZATCA</span>
        <p style={{ color: darkMode ? "#ddd" : undefined }}>
          انطلاقاً من رؤية المملكة 2030 — جاهزون للربط مع هيئة الزكاة والضريبة
          والجمارك (الزكاة والدخل) ومنصة فاتورة، والمرحلة الثانية (الربط والتكامل)
          وضريبة القيمة المضافة VAT.
        </p>
      </div>
      <div className="trust-bar-grid">
        {items.map((item) => (
          <div className="trust-bar-item" key={item.label}>
            <strong style={{ color: darkMode ? "white" : undefined }}>{item.value}</strong>
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrustBar;
